export const backendConfigUrl = '/config/config.json';

const CONFIG = {
  debugMode: false,
  backend: {
    feeds: {
      register: `/registration`,
      languages: `/languages`,
    },
    apiKey: "X5GT5VSrjinjqIsP00js",
  },
};

export default CONFIG;



// WEBPACK FOOTER //
// ./build-config/prod.js